import HNSColors from "../HNSColors";

const commonStyles = {
  label: (isFocused) => ({
    color: isFocused ? HNSColors.secondary[500] : HNSColors.neutrals[400],
    fontWeight: "600",
    fontSize: "16px",
    mb: 0.5,
  }),
  textField: {
    "& .MuiOutlinedInput-root": {
      padding: "0 !important",
      borderRadius: "8px",
      transition: "border-color 0.3s",
      "& fieldset": {
        borderColor: HNSColors.neutrals[400],
      },
      "&.Mui-focused fieldset": {
        border: `1.5px solid ${HNSColors.secondary[500]}`,
      },
      "& .MuiInputBase-input": {
        padding: "12px !important",
      },
      "& .MuiInputBase-input textarea": {
        padding: "12px !important",
      },
      "& .MuiSelect-icon": {
        color: HNSColors.primary[500],
      },
    },
  },
};

export default commonStyles;
